/* eslint-disable no-console */
export default function () {
  if (window.apm && window.apm.isActive()) {
    try {
      window.apm.captureError(
        arguments.length === 1 && arguments[0] instanceof Error
          ? arguments[0]
          : new Error(JSON.stringify(arguments))
      );
    } catch (error) {
      //
    }
  } else {
    console.error(...arguments);
  }
}
